import { useEffect, useState } from "react";
import { applyDensity, loadDensity, type Density } from "../prefs";
import { Icons } from "./Icons";

/* Comfortable or compact. One button rather than a pair: there are only two
   states, and the header already has three theme buttons beside it. */
export function DensityToggle() {
  const [density, setDensity] = useState<Density>(loadDensity);

  useEffect(() => {
    applyDensity(density);
  }, [density]);

  // The palette can flip it too; keep this button's pressed state honest.
  useEffect(() => {
    const observer = new MutationObserver(() =>
      setDensity(document.documentElement.dataset.density === "compact" ? "compact" : "comfortable"),
    );
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["data-density"] });
    return () => observer.disconnect();
  }, []);

  const compact = density === "compact";
  return (
    <button
      type="button"
      className="ghost icon-only density-toggle"
      aria-pressed={compact}
      title={compact ? "Comfortable spacing" : "Compact spacing"}
      aria-label="Compact spacing"
      onClick={() => setDensity(compact ? "comfortable" : "compact")}
    >
      {Icons.density}
    </button>
  );
}
